import React, { Component } from 'react';
import ErrorPage from './ErrorPage';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Aktualisieren Sie den Zustand, um anzuzeigen, dass ein Fehler aufgetreten ist
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Hier können Sie den Fehlerbericht an einen Fehlerüberwachungsdienst senden
    console.error('Fehlerbericht:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Zeigen Sie die Fehlerseite an, wenn ein Fehler aufgetreten ist
      return <ErrorPage />;
    }

    // Rendern Sie die Kindkomponenten normalerweise
    return this.props.children;
  }
}

export default ErrorBoundary;
